import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "Shepard tones are an acoustical illusion of an infinitely rising or falling scale that never exceeds the limits of human hearing. In this example, you are able to listen to a shepard scale including a downward moving pitch (falling Shepard-Risset glissando), which is visualized in the spectrogram below.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 5],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Shepard tones",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "video",
                options: {
                  src: `${config.ASSETS_URL}/02/30/principle/slide-3.m4v`,
                },
              },
              styles: {
                padding: "1% 9%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
